import React, {useEffect, useState} from 'react';
import {Container, Grid } from '@material-ui/core/';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {AddCircle,PermContactCalendar } from '@material-ui/icons';
import Form from 'components/Form/FormTwoColumns';
import ApiServices from 'services/ApiServices';
import {showMessageSuccessSimple, showMessagePersonalizedPosition} from 'services/SweetAlert'
import Title from 'components/TitleWithIcon';
import DialogLoadingMessage from 'components/LoadingMessage/index'
import DialogRegistrarPeriodosSinRegistro from 'components/CustomDialog';

function RegistrarPeriodosSinRegistro(props) {
    var saveData = {}
    let idDepartamento = '', isReturn = false;
    let description = [
        {name: "- Antes de continuar, revise que la información que ingresó esté correcta.",},
        {name: "- Datos requeridos (*)."}
    ]

    const classes = useStyles(),
        [mensaje, setMensaje] = useState({loading: false, title:''});

    const obtenerDepartamentos =async ()=>{
        setMensaje({loading: true, title: 'Cargando catálogo de departamentos ...'})
        let newElements= Object. assign({}, elements); 
        if(props.catalogos.departamentos.length === 0){
            try{
                let response = await ApiServices.catalogoDepartamentosDicep.listRegisterCriteria();
                newElements.coddepto.list=[];
                if(response.error){
                    showMessagePersonalizedPosition('error','Oopss!', response.error.message,'center')
                }else {  
                    newElements.coddepto.list = response.data
                    props.MODULO_FALLECIDOS_SET_CATALOGO_DEPARTAMENTOS(response.data)
                } 
            }catch(exception){
                if (exception.status===404) {
                    showMessagePersonalizedPosition('error', '¡Oops! ' ,"Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.")
                }
                else {
                    showMessagePersonalizedPosition('error', '¡Oops! ' ,"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.")
                }                    
                newElements.coddepto.list=[];
            }            
        }else{
            newElements.coddepto.list = props.catalogos.departamentos
        }
        setElements(newElements);
        setMensaje({loading: false, title: ''})
    };
    //consultar en el store por medio del iddepartamento si existe ya un municipio    
    const ObtenerMunicipiosEnMemoriaFallecidos = (idDepartamento) =>{
        let newElements= Object. assign({}, elements); 
        if(elements.coddepto?.value?.id === undefined){
            elements.codmunic.list = [];
            elements.codmunic.list =  null;
            return true;
        }
        if(idDepartamento?.target?.value === ""){
            elements.codmunic.list = []
            elements.codmunic.value = null
            return true;
        }
        
        const currentMunicipality = props.catalogos?.municipios?.filter( ({departamentoId}) => Number(departamentoId) === Number(idDepartamento));
        if(currentMunicipality?.length > 0) {
            newElements.codmunic.list=currentMunicipality;
            setElements(newElements);
            setMensaje({loading: false, title:''})
            return true;
        } else return false;
    }    
    //cargamos los municipios en base al departamento seleccionado        
    const obtenerMunicipios =async (event)=>{
        setMensaje({loading: true, title: 'Cargando catálogo de municipios ...'})        
        let newElements= Object. assign({}, elements); 
        if(event?.target?.value) {
            newElements.codmunic.value = null
            idDepartamento = event.target.value;
        }
        else idDepartamento = event;

        if(idDepartamento === undefined && elements.coddepto.value?.id) idDepartamento = elements.coddepto.value?.id;

        isReturn = ObtenerMunicipiosEnMemoriaFallecidos(idDepartamento)
        if(isReturn){
            setMensaje({loading: false, title:''})
            return;
        }

        try{
            ApiServices.catalogoMunicipiosDicep.searchCriteria.clear();
            ApiServices.catalogoMunicipiosDicep.searchCriteria.setOperator("and");
            ApiServices.catalogoMunicipiosDicep.searchCriteria.addEquals("departamentoId",idDepartamento);
            ApiServices.catalogoMunicipiosDicep.setIsPublic(true);
            let response =await ApiServices.catalogoMunicipiosDicep.listRegisterCriteria();
            if(response.error){
                showMessagePersonalizedPosition('error','Oopss!', response.error.message,'center')
                newElements.codmunic.list=[];
            }else {                
                newElements.codmunic.value = null
                newElements.codmunic.list = response.data
                props.MODULO_FALLECIDOS_SET_CATALOGO_MUNICIPIOS(response.data)
            }
        }catch(exception){
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Oops! ' ,"Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
            }
            else {
                showMessagePersonalizedPosition('error', '¡Oops! ' ,"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
            }            
            newElements.codmunic.list=[];
        }
        setElements(newElements);
        setMensaje({loading: false, title: ''})
    };

    const agregarDatosOpcionalesALaPeticion = () => {
        saveData.apellido1fallecido=''
        saveData.apellido1madre=''
        saveData.apellido1padre=''
        saveData.apellido2fallecido=''
        saveData.apellido2madre=''
        saveData.apellido2padre=''
        saveData.apellido3fallecido=''
        saveData.cui=''
        saveData.estado=''
        saveData.fechadefuncion=''
        saveData.fechanacimiento=''
        saveData.nombre1fallecido=''
        saveData.nombre2fallecido=''
        saveData.nombremadre=''
        saveData.nombrepadre=''
        saveData.nroboleta=''
        saveData.nroorden=''
        saveData.nroregistro=''
    }
    const AgregarRegistro= async ()=>{
        setMensaje({loading: true, title: 'Registrando periodo sin Registro ...'})
        var datosDelFormulario = elements
        Object.keys(datosDelFormulario).forEach((element, key, _array) =>{
            if(datosDelFormulario[element].idelement === 'coddepto' || datosDelFormulario[element].idelement === 'codmunic'){
                saveData[datosDelFormulario[element].idelement] = datosDelFormulario[element].value.id;
            }
            else if(datosDelFormulario[element].elementType === 'date'){
                saveData[datosDelFormulario[element].idelement] = new Date(datosDelFormulario[element].value);
            }
            else if(datosDelFormulario[element].idelement === 'password'){
                saveData[datosDelFormulario[element].idelement] = datosDelFormulario[element].value;
            }
            else if(datosDelFormulario[element].idelement !== 'titleFolio' && datosDelFormulario[element].idelement !== 'firmaElectronica') 
            {
                saveData[datosDelFormulario[element].idelement] = typeof datosDelFormulario[element].value === 'string' ?  datosDelFormulario[element].value.toUpperCase(): datosDelFormulario[element].value;
            }
        })
        agregarDatosOpcionalesALaPeticion(saveData)
            try{
                const response =  await ApiServices.captacionFallecidos.captacionFallecido(saveData)
                if(response.error!==null){
                    showMessagePersonalizedPosition('warning', '¡Oops! ' ,response.error.message)
                }else{
                    showMessageSuccessSimple('¡BIEN!', response.data)
                    props.actualizarTabla()
                    Cancelar();
                }   
            }catch(exception){
                if (exception.status===404) {
                    showMessagePersonalizedPosition('error', '¡Oops! ' ,"Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.")
                }
                else {
                    showMessagePersonalizedPosition('error', '¡Oops! ' ,"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.")
                }
            }                 
            setMensaje({loading: false, title: ''})
    };
        
    const Cancelar=()=>{
        props.closeModal()
    };    

    const keyPressAsignarFolio = async (event) => {
        if (event.key === "Enter") {
            setMensaje({loading: true, title: 'Obteniendo folio, espere por favor ...'})
            if(event.target.value === ''){
                showMessagePersonalizedPosition('warning','¡Oopss!', 'Por favor ingrese No. Folio','center')
            }else{
                try{
                    const response =  await ApiServices.captacionFallecidos.obtenerDeptoMuni(event.target.value)
                    if(response.error!==null){
                        showMessagePersonalizedPosition('error','Oopss!', response.error.message,'center')
                        elements.coddepto.value = null
                        elements.codmunic.value = null
                    }else{
                        obtenerMunicipios(response.data.departamento.id)
                        showMessagePersonalizedPosition('success','¡BIEN!', 'Folio asignado correctamente','center')
                        elements.coddepto.value = response.data.departamento
                        elements.codmunic.value = response.data.municipio
                    }   
                }catch(exception){
                    if (exception.status===404) {
                        showMessagePersonalizedPosition('error','Oopss!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
                    }
                    else {
                        showMessagePersonalizedPosition('error','Oopss!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
                    }
                }                             
            }
            setMensaje({loading: false, title: ''})
        }
      };
    
    const [elements,setElements] = useState({
        titleFolio:{
            idelement: "titleFolio",title:'Datos Generales del Folio', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },    
            nrofolio: {
                idelement: "nrofolio",  value:'', label: "No. Folio *", pattern:"^[\\w1-9_Ññ-]{1,11}$", keyPress: keyPressAsignarFolio,
                validators: ['required'], errorMessages:['Ingrese No. Folio, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },
            año: {
                idelement: "año",  value:'', label: "Año de folio *", pattern:"^[0-9]{4,4}$",
                validators: ['required'], errorMessages:['Ingrese Año de Folio, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },
            coddepto: {
                idelement: "coddepto", value: null, label: "Departamento *", pattern:"^[1-9][0-9]*$", validators: ['required'],
                errorMessages:['Seleccione el Departamento'], isError:false, elementType:'autocompleteV2', list: [], handler: obtenerMunicipios,
                focus: {ejecutar: true, function: obtenerDepartamentos},                
            },
            codmunic: {
                idelement: "codmunic", value: null, label: "Municipio *", pattern:"^[1-9][0-9]*$", validators: ['required'], 
                errorMessages:['Seleccione el Municipio'], isError:false, elementType:'autocompleteV2', list: [], 
                focus: {ejecutar: true, function: obtenerMunicipios},
            },
            fechainicio: { 
                idelement: "fechainicio", value: null, label: "Ingrese Fecha Inicio *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required'], 
                errorMessages:['Ingrese Fecha Inicio'], isError:false, elementType:'date' 
            },            
            fechafinal: { 
                idelement: "fechafinal", value: null, label: "Ingrese Fecha Fin *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required'], 
                errorMessages:['Ingrese Fecha Fin'], isError:false, elementType:'date' 
            },            
        firmaElectronica:{
            idelement: "firmaElectronica",title:'Ingrese Firma Electrónica', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },            
            password: { idelement: "password",  value:'', label: 'Ingrese contraseña', pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,20}$", validators: ['required'], errorMessages:['Contraseña requerida'], isError:false, elementType:'password' },        
    });    
    
    const [buttonList,setButtonList]= React.useState({
        "next":{"label":"Registrar Registro","icon": <AddCircle />,"callback":AgregarRegistro,"loading":mensaje.loading, disabled:mensaje.loading, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",},   
    });

    return (
        <DialogRegistrarPeriodosSinRegistro
            title={props.title}
            open={props.open}
            fullScreen={true}
            closeModal={props.closeModal}
            actualizarTabla={props.actualizarTabla}
            iconToolbar={<PermContactCalendar />}
            titleToolbar={props.titleToolbar}        
        >
            <DialogLoadingMessage open={mensaje.loading} title={mensaje.title}/>
            <Title title="Complete el formulario para registrar el periodo sin registro" icon={"/menu/Document.png"}/>

            <div className={classes.colorComponente}>
                <Grid >
                    <Grid className={classes.AlignTable} item xs={12} direction="row" justify="center" alignItems="center"> <br/>
                        <Form   elements= {elements}  buttonList={buttonList} BotonCerrar={Cancelar} description={description}/>
                    </Grid>           
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </div><br/>
        </DialogRegistrarPeriodosSinRegistro>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(RegistrarPeriodosSinRegistro);